export const decisioningStudioAgentsAppGroupIdDsaIdPerformanceReportData =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/performance_report/data";
